export default "__VITE_ASSET__06f32b69__"